import "../css/Home.css"
import video from "../media/timelapse.mp4"
import myPic from "../media/mypic.jpeg"

export default function Home() {
    
    return <section className="home-container">
    <div>
    <video autoPlay muted id="backgroundVideo" playsinline="true" disablePictureInPicture="true">
     <source src={video} type="video/mp4"/>
    </video>
    </div>
    <div className="intro-container">
        <div>
            <img src={myPic} id="headshot" alt="Headshot of Solveiga"></img>
        </div>
        <div className="home-hello">
            <h1>Hi! My name is Solveiga</h1>
            <p>I'm a junior software developer looking for my first role.</p>
            <p>Welcome to my Portfolio Page!</p>
        </div>
    </div>
</section>
}